<template>
  <div>
    <b-modal
      ref="openModal"
      class="filterDateModal"
      scrollable
      size="sm"
      :title="title"
      @ok="onConfirm"
      @cancel="onCancel"
    >
      <label>{{ message }}</label>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  methods: {
    show() {
      this.$refs.openModal.show();
    },
    hide() {
      this.$refs.openModal.show();
    },
    onCancel() {
      this.$emit("cancel");
      this.$refs.openModal.hide();
    },
    onConfirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>

